export const nextPage = sequence => {
  const next = sequence.find(page => page.is_completable && !page.is_completed)

  return next ? next : sequence[0]
}

export const nextPageByOrder = ({ sequence, currentPageId }) => {
  const currentIndex = sequence.findIndex(
    page => page.page_id === currentPageId
  )
  const next = sequence
    .slice(currentIndex + 1)
    .find(page => page.is_completable)

  return next ? next : sequence.slice(currentIndex)[0]
}
